'use client';

import dynamic from 'next/dynamic';

export const BoxModelQuiz = dynamic(() => import('./BoxModelQuiz'));
export const HeightAccordionDemo = dynamic(
  () => import('./HeightAccordionDemo')
);
export const NoInterpolateSize = dynamic(
  () => import('./NoInterpolateSize')
);
